import type { RouteRecordRaw } from "vue-router"

export const FlowRoutes: RouteRecordRaw[] = [
  {
    name: "flow.routes",
    path: "",
    components: {
      layout: () => import("@/components/layout/PlainLayout.vue"),
    },
    children: [
      {
        name: "start",
        path: "/start",
        meta: {
          public: true,
        },
        children: [
          {
            name: "start-default",
            path: "",
            component: () => import("./StartFlowPage.vue"),
          },

          {
            name: "start-with-token",
            path: "tokens/:token/:mode?",
            component: () => import("./StartFlowPage.vue"),
            props: true,
          },
          {
            name: "start-with-entity-key",
            path: "entity-keys/:entityKey",
            component: () => import("./StartFlowPage.vue"),
          },
        ],
      },
      {
        name: "finish",
        path: "/finish",
        alias: ["/exit"],
        component: () => import("./FinishFlowPage.vue"),
        props: (to) => to.query,
        meta: {
          public: true,
          preventBack: true,
        },
      },
    ],
  },
]
